import { graphql, graphqlOperation } from "../modules/AmplifyServices";
import { execReadByPK } from "../modules/DBService";
import { ordersByClientCreatedAt } from "../queries/CustomQueries";
import _ from "lodash";

/**
 * Get order by client package id
 * Pulls all order for a clientId and then filters by the packageId
 * @param {string} clientId - client id
 * @param {string} pkgId - package id
 * @returns {object} order
 */
export const getOrderByClientPackageId = async (clientId, pkgId) => {
    const result = await execReadByPK({
        opname: "ordersByClientCreatedAt",
        op: ordersByClientCreatedAt,
        id: { clientId: clientId },
        sortDirection: "DESC"
    });
    return _.find(
        result.items,
        (order) =>
            _.get(order, "clientpackage") &&
            _.get(order, "clientpackage.id") === pkgId
    );
};
